import { handleNarIngestionApiCall } from "./handleNarIngestionApiCall";

interface HandleApproveNarIngestionParams {
  payerType: string;
  subType: string;
  month: number;
  year: number;
  documentType: string;
  setIsSubmitting?: (isSubmitting: boolean) => void;
}

export const handleApproveNarIngestion = async ({
  payerType,
  subType,
  month,
  year,
  documentType,
  setIsSubmitting,
}: HandleApproveNarIngestionParams) => {
  // Call the dynamic API function with ingest=true for approval
  await handleNarIngestionApiCall({
    payerType,
    subType,
    month,
    year,
    documentType,
    ingest: true, // Approval action
    setIsSubmitting,
  });
};
